var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-card',[_c('h2',[_vm._v(_vm._s(_vm.$t("profile.settings.header")))]),(_vm.loaded)?_c('Settings'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }